import HomeNavbar from "../../components/homepage/HomeNavbar";
import Footer from "../../components/homepage/Footer";
import { StyledHome } from "./Home.styled";
import Showcase from "../../components/homepage/Showcase";
import WhatWeOffer from "../../components/homepage/WhatWeOffer";
import GetStarted from "../../components/homepage/GetStarted";
import OtherProducts from "../../components/homepage/OtherProducts";
import OurPricing from "../../components/homepage/OurPricing";
import Clients from "../../components/homepage/Clients";
import YoutubeReview from "../../components/homepage/YoutubeReview";


const Home = () => {

  return (
    <StyledHome>
      <>
        <div className="">
          <HomeNavbar />
          <Showcase />
          <WhatWeOffer />
          <GetStarted />
          <Clients />
          <YoutubeReview />
          <OtherProducts />
          <OurPricing />
        </div>
        <Footer />
      </>
    </StyledHome>

  );
};

export default Home;
